<div class="registaration">
  <div class="r-header">
    <img src="assets/images/logo-dark.svg" alt="">
  </div>
  <div class="sidebar">
    <img src="assets/images/logo2.svg" class="logo" alt="Luqta">
    <h2>
      Secure your subscription and manage everything in one place.
    </h2>
    <img src="assets/images/r-sidebar-v.svg" class="r-sidebar-v animated" alt="">
  </div>
  <div class="form-body">
    <div class="successfully-payment">
      <img src="assets/images/reject-icon.png" class="check" alt=""
        onerror="this.src='assets/images/check222.png'; this.style.filter='hue-rotate(180deg)'">
      <h3 class="title" style="color: #e74c3c;">
        Payment Rejected
      </h3>
      <p>Your SDK payment could not be processed. Please try again.</p>
      <button class="btn btn-primary btn-md w-100" (click)="retryPayment()">
        Try Again
      </button>
      <button class="btn btn-primary-outline btn-md w-100" (click)="goToHomepage()">
        Go to Homepage
      </button>
    </div>
  </div>
</div>
